import { DevicePreviewEnum, type DTFile, type FieldADTValue, type FieldProtocol, type FileValue } from '@lighthouse/core'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import { useApplicationContext } from '../../contexts'
import type { EnableActionsParams, FetchPexelsParams, PexelsResponse } from '../../types'
import { FileListPreviewer } from '../FileUploader/FileListPreviewer'
import type { UseUploadFileSParameter } from '../UploadManage'

const SCxDiv = styled.div`
    width: 100%;
`

interface FileValueEditorProps {
    dsId: string
    recordId: string
    field: FieldProtocol
    data?: FileValue
    enableFileDownload?: boolean
    uploadyOptions: Pick<UseUploadFileSParameter, 'info' | 'options'>
    onCellChange?: (recordId: string, data: FieldADTValue) => Promise<boolean>
    onFetchPexelsList: (params: FetchPexelsParams) => Promise<PexelsResponse>
}

export const FileValueEditor: React.FC<FileValueEditorProps> = ({
    dsId,
    recordId,
    data,
    field,
    uploadyOptions,
    enableFileDownload,
    onCellChange,
    onFetchPexelsList
}) => {
    const enableItemActions: EnableActionsParams = { canDownload: enableFileDownload, canPreview: true, canDelete: true }
    const { isBuilder } = useApplicationContext()
    const handleChange = useCallback(
        (data: DTFile[]) => {
            onCellChange?.(recordId, { ...field, type: 'file', value: data })
        },
        [field, onCellChange, recordId]
    )
    const isAvatarField = field.id === 'AVATAR'
    const disableUpload = isAvatarField && data && data?.length >= 1

    return (
        <SCxDiv>
            <FileListPreviewer
                previewType={DevicePreviewEnum.DESKTOP}
                id={`${dsId}-${field.id}-${recordId}`}
                accept={isAvatarField ? 'image/*' : undefined}
                isPexels={isBuilder && !isAvatarField}
                uploadyOptions={uploadyOptions}
                enableItemActions={enableItemActions}
                onChange={handleChange}
                files={data || []}
                autoOpenWhenEmpty
                isUsedLink={!isAvatarField}
                disableUpload={disableUpload}
                multiple={!isAvatarField}
                onFetchPexelsList={onFetchPexelsList}
            />
        </SCxDiv>
    )
}
